import * as React from 'react';

import { SurveyConfig } from '../types';

const useSurvey = (config: SurveyConfig) => {
  const questions = React.useMemo(
    () =>
      Object.fromEntries(
        config.questions.map((q, idx) => [q.uid, { ...q, idx }])
      ),
    [config]
  );

  const [currentQuestionUid, setCurrentQuestionUid] = React.useState(
    config.questions[0].uid
  );

  const currentQuestion = questions[currentQuestionUid];

  const currentQuestionIdx = questions[currentQuestionUid].idx;

  const totalQuestions = config.questions.length;

  const hasPrevQuestion = currentQuestionIdx > 0;

  const hasNextQuestion = currentQuestionIdx + 1 < totalQuestions;

  const goToPrevQuestion = React.useCallback(() => {
    if (hasPrevQuestion) {
      const prevQuestionUid = config.questions[currentQuestionIdx - 1].uid;
      setCurrentQuestionUid(prevQuestionUid);
    }
  }, [hasPrevQuestion, config, currentQuestionIdx, setCurrentQuestionUid]);

  const goToNextQuestion = React.useCallback(() => {
    if (hasNextQuestion) {
      const nextQuestionUid = config.questions[currentQuestionIdx + 1].uid;
      setCurrentQuestionUid(nextQuestionUid);
    }
  }, [hasNextQuestion, config, currentQuestionIdx, setCurrentQuestionUid]);

  return {
    currentQuestion,
    currentQuestionIdx,
    totalQuestions,
    hasPrevQuestion,
    hasNextQuestion,

    goToPrevQuestion,
    goToNextQuestion
  };
};

export default useSurvey;
